module.exports = __webpack_public_path__ + "img/bg-detail-report.5536fc15.png";